export const WA_NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER || "919007337749";
export const WA_MESSAGE =
  process.env.REACT_APP_WHATSAPP_MESSAGE ||
  "Hello AccuSurge, I would like to discuss a healthcare requirement.";

export const waLink = (msg) =>
  `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(msg || WA_MESSAGE)}`;

export const trackEvent = (name, data = {}) => {
  if (typeof window !== "undefined" && window.trackEvent) window.trackEvent(name, data);
};

export const REQUIREMENT_TYPES = [
  "Hospital Setup",
  "Medical Equipment",
  "Hospital Furniture",
  "Dialysis Centre",
  "Diagnostic Centre",
  "Surgical Products",
  "Consumables",
  "Financing Support",
  "Licensing & Accreditation",
  "Maintenance / Service",
  "Other",
];
